export const momentDateFormat = 'DD.MM.YYYY';
export const defaultDateFormat = 'dd.MM.yyyy';
export const apiDateFormat = 'yyyy-MM-dd';
